import { connect } from 'react-redux';
import { get } from 'lodash';

import { isUserLoggedIn } from 'apps/user/helpers';
import basketModes from 'apps/basket/utils/basketModes';
import { setSuccessMessage, setErrorMessage } from 'apps/notifications/actions/notifications';
import { fetchDeliverySlot } from 'apps/deliverySlot/actions/deliverySlot.js';
import { fetchUserData } from 'apps/user/actions/user.js';

import ShopControl from '../components/ShopControl';
import { fetchBasket } from 'apps/basket/actions/basket';

export default connect(
  (state) => {
    const slotExpirationTime = get(state, 'deliverySlot.expirationTime');
    const userBetaFeatures = get(state, 'user.betaFeatures', []);
    const isAlternativeHeaderVerO =
      userBetaFeatures.includes('ALTERNATIVE_HEADER') && userBetaFeatures.includes('ALTERNATIVE_HEADER_VER_O');

    return {
      cutoffTime: get(state, 'deliverySlot.cutoffTime') || slotExpirationTime,
      isBasketInEditMode: state.basket.mode === basketModes.EDIT,
      isLoggedIn: isUserLoggedIn(state.user),
      deliverySlot: get(state, 'deliverySlot'),
      customerNumber: get(state, 'customerNum'),
      hasOrderBeenCutOff: get(state, 'user.accountDetails.userMessages', []).includes('ORDER_CUTOFF'),
      shouldShowCheckout: !isAlternativeHeaderVerO,
    };
  },
  {
    setErrorMessage,
    setSuccessMessage,
    fetchDeliverySlot,
    fetchBasket,
    fetchUserData,
  }
)(ShopControl);
